<template>
  <div class="ucinfoPage">
    <div class="login-bg">
      <div class="infoHead"> 
        <mu-avatar  slot="left" src="http://imgserver.xurigo.com/images/headpic.png" :size="60"/>
        <div class="totalCoin">
          <p class="totalTitle"><i class="fa fa-money"></i>总资产<i class="fa fa-angle-right"></i></p>
          <p class="totalNum"><span>49.585858</span></p>
        </div>
      </div> 
      <div class="bouns" :style="{width:bounsWidth+'px'}">  
        <div class="coin">   
            <div class="grant">
              <p class="text">静态通证<i class="fa fa-angle-right"></i></p>
              <p class="count"><span>23.555</span></p>        
            </div>          
            <div class="put">
              <p class="text">动态通证<i class="fa fa-angle-right"></i></p>
              <p class="count"><span>14.333</span></p>                 
            </div>  
             <div class="totalCoin">
              <p class="totalTitle">花粉<i class="fa fa-angle-right"></i></p>
              <p class="totalNum"><span>49.585858</span></p>
            </div>
        </div>
      </div>
    </div>
    <mu-list>
      <mu-list-item class="item" title="我的登录账户">
          <mu-avatar slot="left" icon=":fa fa-user" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
          <span slot="right"> 18554988766</span>
      </mu-list-item>
      <mu-list-item class="item" title="推荐码">
          <mu-avatar slot="left" icon=":fa fa-mydianzhu" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
          <mu-icon slot="right" value=":fa fa-angle-right" color="#999" :size="18"/>
      </mu-list-item>
      <mu-list-item class="item" title="我的钱包地址">
          <mu-avatar slot="left" icon=":fa fa-withdraw" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
         <mu-icon slot="right" value=":fa fa-angle-right" color="#999" :size="18"/>
      </mu-list-item>
    </mu-list>
    <mu-list>
      <mu-list-item class="item" title="邀请好友">
          <mu-avatar slot="left" icon=":fa fa-people3" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
           <mu-icon slot="right" value=":fa fa-angle-right" color="#999" :size="18"/>
      </mu-list-item>
      <mu-list-item class="item" title="我的粉丝">
          <mu-avatar slot="left" icon=":fa fa-people" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
          <mu-icon slot="right" value=":fa fa-angle-right" color="#999" :size="18"/>
      </mu-list-item>
    </mu-list>
    <mu-list>
      <mu-list-item class="item" title="个人设置">
          <mu-avatar slot="left" icon=":fa fa-option" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
          <mu-icon slot="right" value=":fa fa-angle-right" color="#999" :size="18"/>
      </mu-list-item>
      <mu-list-item class="item" title="账户安全">
          <mu-avatar slot="left" icon=":fa fa-lock2" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
          <mu-icon slot="right" value=":fa fa-angle-right" color="#999" :size="18"/>
      </mu-list-item>
      <mu-list-item class="item" title="帮助中心">
          <mu-avatar slot="left" icon=":fa fa-question-circle" color="#999" backgroundColor="#fff" :size="30" :iconSize="20"/>
          <mu-icon slot="right" value=":fa fa-angle-right" color="#999" :size="18"/>
      </mu-list-item>
    </mu-list>
  </div>
</template>
<script>
export default {
  data(){
    return{
      bounsWidth:document.documentElement.clientWidth-20
    }
  },
  mounted:function(){

  },
  methods:{

  },
  watch:{

  }
}
</script>
<style>
 .ucinfoPage .login-bg {
    width: 100%;
    height: 175px;
    position: relative;
    padding: 0 10px;
    justify-content: center;
    background: url('../../../static/IHNY/1.png');
    background-size: 100% 100%;
}
.ucinfoPage .infoHead{
  display: flex;
  padding-top: 12px;
  align-items: center;
}
.ucinfoPage .infoHead .totalCoin{
  color: #fff;
  margin-left: 10px;
}
.ucinfoPage .infoHead .totalCoin .totalNum{
  font-size: 26px;
}
.ucinfoPage .infoHead .totalCoin .totalTitle{
  font-size: 16px;
}
.ucinfoPage .infoHead .totalCoin .fa-angle-right{
  padding-left: 5px;
}
.ucinfoPage .infoHead .totalCoin .fa-money{
  padding-right: 5px;
}
 .ucinfoPage .login-bg img.touxiang{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: relative;
  top: 50px;
  z-index: 1;
}
.ucinfoPage .bouns{
  position: absolute;
  bottom: 10px;
  background: rgba(100,100,100,0.2);
  background-size: 100% 100%;
  border-radius: 15px ;
  text-align: center;
}
.ucinfoPage .login-bg .bouns .coin{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
}
.ucinfoPage .login-bg .bouns .coin div:not(:last-child){
  border-right: 1px dashed #ddd;
}
.ucinfoPage .bouns p{
  font-size: 16px;
  color: #fff;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ucinfoPage .bouns .coin .grant , .ucinfoPage .bouns .coin .put,.ucinfoPage .bouns .coin .totalCoin{
  width: 33.3%;
  z-index: 1;
  color: #fff;
}
.ucinfoPage .login-bg .bouns .totalCoin .totalTitle .fa-money{
  color: #fff;
  padding-right:  5px;
}
.ucinfoPage .login-bg .bouns .fa-angle-right{
  padding-left: 5px;
}
.ucinfoPage .login-bg .mu-avatar{
  
}
.ucinfoPage .mu-list{
  background: #fff;
  width: 95%;
  margin:15px 2.5% 0 ;
  border-radius: 15px;
  padding:10px;
  box-shadow: 0px 0px 5px #ddd;
}
.ucinfoPage .mu-list .mu-item.show-left{
  padding-left: 40px;
}
.ucinfoPage .mu-list .item:not(:last-child){
  border-bottom: 1px solid #f5f5f5;
}
.ucinfoPage .mu-list .mu-item-left{
  left: 0;
}
.ucinfoPage .mu-list .mu-item-right{
  width: auto;
}
</style>




// WEBPACK FOOTER //
// src/pages/IHNY/ucinfo.vue